import { LinearGradient } from 'expo-linear-gradient';
import styled from 'styled-components/native';

export const Container = styled.View`
  height: 15px;
`;

export const GradientView = styled(LinearGradient)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 15;
`;
export const WhiteView = styled.View`
  position: absolute;
  left: 0;
  right: 0;
  top: 15;
  height: 45;
  background-color: white;
  width: 100%;
  flex-direction: row;
  padding-left: 320px;
  justify-content: space-between;
  align-items: center;
  padding-right: 180px;
`;

export const BackButtonContainer = styled.TouchableOpacity`
  padding: 10px;
  flex-direction: row;
`;

export const TextWrapper = styled.Text`
  color: #4258db;
  font-size: 20;
  font-weight: bold;
`;
export const LogoutContainer = styled.Text`
  color: black;
  font-size: 20;
  font-weight: bold;
`;
